"use client";

import { createContext } from "react";

/** SSR: предпочтение посетителя (cookie / color-scheme) для colorScheme=auto. */
export const LandingThemeInitialDarkContext = createContext<boolean | undefined>(
  undefined,
);
